/**
 * SMEClimateSnapshot — /sme/climate-snapshot
 * Renders the Monthly Trends page pre-focused on the Trend tab
 */
import React from "react";
import SMEEvolutionView from "./SMEEvolutionView";
import { PageHeader, SectionCard, MetricCard, CTAButton } from "@/components/ds";
export default function SMEClimateSnapshot() {
  return <SMEEvolutionView defaultView="trend" />;
}
